module.exports = __webpack_public_path__ + "media/8.6d91e961.ogg";